import { Link, useLocation } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore'
import { authAPI } from '../../services/api'
import QuotaIndicator from '../auth/QuotaIndicator'
import { FeedbackButton } from '../../features/feedback'

export default function Header() {
  const location = useLocation()
  const {
    isAuthenticated,
    user,
    openLoginModal,
    logout: logoutStore,
  } = useAuthStore()

  const handleLogout = async () => {
    try {
      await authAPI.logout()
    } catch (error) {
      console.error('Erreur logout:', error)
    }
    
    // Toujours nettoyer le state local
    logoutStore()
    
    // Supprimer aussi le cookie côté client (backup)
    document.cookie = 'session_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    
    // Forcer la redirection vers /app (pas juste reload)
    window.location.href = '/app'
  }

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Feedback + Logo + Nom */}
          <div className="flex items-center gap-4">
            <FeedbackButton />
            <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 bg-medical-blue rounded-lg flex items-center justify-center">
              <svg
                className="w-6 h-6 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
                />
              </svg>
            </div>
            <div>
              <h1 className="text-lg font-semibold text-gray-900">
                RISK-DATA
              </h1>
              <p className="text-xs text-gray-500">
                Base de données toxicologiques professionnelles
              </p>
            </div>
          </Link>
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                location.pathname === '/'
                  ? 'text-blue-600 bg-blue-50'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
              }`}
            >
              Recherche
            </Link>
            <Link
              to="/duerp"
              className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                location.pathname.startsWith('/duerp')
                  ? 'text-blue-600 bg-blue-50'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
              }`}
            >
              Mes DUERP
            </Link>
            <a
              href={import.meta.env.DEV ? 'http://localhost:3000/mode-emploi' : '/mode-emploi'}
              target="_blank"
              rel="noopener noreferrer"
              className="px-3 py-2 text-sm font-medium rounded-lg transition-colors text-gray-600 hover:text-gray-900 hover:bg-gray-100"
            >
              Mode d'emploi
            </a>
          </nav>

          {/* Actions: Quota + Auth */}
          <div className="flex items-center gap-4">
            {/* Quota indicator */}
            <div className="hidden sm:block">
              <QuotaIndicator variant="badge" />
            </div>

            {/* Auth */}
            {isAuthenticated ? (
              <div className="flex items-center gap-3">
                <div className="hidden md:block text-right">
                  <p className="text-sm font-medium text-gray-900">
                    {user?.email?.split('@')[0]}
                  </p>
                  {/* Statut abonnement - masqué en production */}
                  {import.meta.env.DEV && (
                    <p className="text-xs text-gray-500">
                      {user?.isSubscribed ? 'Abonné' : 'Gratuit'}
                    </p>
                  )}
                </div>
                <button
                  onClick={handleLogout}
                  className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                  title="Déconnexion"
                >
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                    />
                  </svg>
                </button>
              </div>
            ) : (
              <button
                onClick={openLoginModal}
                className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
                <span className="hidden sm:inline">Connexion</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}
